import { List } from 'immutable';

import { type TunerVarData } from 'src/types/globals/webpack';

import { TunerVarsActions, TunerVarStateKeys } from '../constants/TunerVarStateKeys';
import { getTunerVarsInitialState } from '../lib/configuration';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map<TunerVarData>({
  [TunerVarStateKeys.SEARCH_REDIRECT_ON_STARTUP]: null,
  [TunerVarStateKeys.STREAMING_INACTIVITY_TIMEOUT_MS]: null,
  [TunerVarStateKeys.MAX_NUM_ANON_PLAYTIME_SECONDS]: null,
  [TunerVarStateKeys.CS_AUTH_TOKEN]: null,
  [TunerVarStateKeys.PASSWORD_RESET_TOKEN]: null,
  [TunerVarStateKeys.OFFER_CODE]: null,
  [TunerVarStateKeys.AUTOPLAY_ON_STARTUP_DISABLED]: false,
  [TunerVarStateKeys.APPLICATION_HOSTNAME]: '',
  [TunerVarStateKeys.APPLICATION_PORT]: 0,
  [TunerVarStateKeys.PAID_HOSTNAME]: '',
  [TunerVarStateKeys.FORCE_FLASH]: false,
  [TunerVarStateKeys.REQUIRE_PAYPAL_CONFIRMATION]: false,
  [TunerVarStateKeys.COUNTRY_CODE]: null,
  [TunerVarStateKeys.CAN_DISPLAY_SAMPLES]: false,
  [TunerVarStateKeys.POSTAL_CODE_VALIDATION_REGEXP]: null,
  [TunerVarStateKeys.TEST_ARTIST_MESSAGE]: '',
  [TunerVarStateKeys.IS_AAMF_FLAGGING_V2]: null,
  [TunerVarStateKeys.FACEBOOK_REF_TOKEN]: null,
  [TunerVarStateKeys.FACEBOOK_SHARE_APP_ID]: null,
  [TunerVarStateKeys.FACEBOOK_CONNECT_PERMISSIONS]: null,
  [TunerVarStateKeys.FACEBOOK_TRACK_SHARE_BASE_URL]: null,
  [TunerVarStateKeys.TWITTER_SHARE_CONSUMER_KEY]: null,
  [TunerVarStateKeys.TWITTER_SHARE_CONSUMER_SECRET]: null,
  [TunerVarStateKeys.AUDIO_PLAYER_SUPPORTED_BROWSERS]: Map(),
  [TunerVarStateKeys.SUPPORTED_BROWSERS]: List(),
  [TunerVarStateKeys.ON_DEMAND_ARTIST_MESSAGE_DATA]: null,
  [TunerVarStateKeys.INITIAL_PANDORA_ID]: null,
}).mergeDeep(getTunerVarsInitialState());
export type TunerVarsState = typeof INITIAL_STATE;

// TUNERVARS REDUCER
export default createReducer(INITIAL_STATE, {
  [TunerVarsActions.CLEAR_ON_DEMAND_ARTIST_MESSAGE_DATA]: clearOnDemandArtistMessageData,
});

// CASE FUNCTIONS

function clearOnDemandArtistMessageData(state: TunerVarsState): TunerVarsState {
  return state.set(TunerVarStateKeys.ON_DEMAND_ARTIST_MESSAGE_DATA, null);
}
